import React from "react";

import DateCell from "$components/table/cells/date.js";
import Flags from "$components/flags";
import LargeNumber from "$components/info-list/content/large-number";
import LogoCell from "$components/table/cells/logo";

import { abbrNum } from "$utils/number-helper";
import { getTerm } from "$stores/dictionary";
import { DateFilter, MultiRangeFilter, SelectColumnFilter } from "$components/table/components/filters/filter";

export const buildProjectsManagedColumns = ({ filterOptions, globalFilterRanges }) => {
    return [
        {
            Header: () => "Name",
            accessorKey: "name", // accessor is the "key" in the data
            id: "name", // id is used as a sort key (i.e., actual api name)
        },
        {
            Header: () => getTerm("projectType"),
            accessorKey: "projectType", // accessor is the "key" in the data
            id: "projectType", // id is used as a sort key (i.e., actual api name)
            Cell: ({ data, value }) => (
                <div>
                    <Flags data={[{ classnames: { "-independence": data.requiresIndependence }, label: "Check Conflicts" }]} />
                    {value}
                </div>
            ),
        },
        {
            Header: () => getTerm("parentClient"),
            accessorKey: "clientGroupName",
            id: "clientGroupName",
            Cell: ({ data, value }) => <LogoCell value={value} logoUrl={""} />, // TODO: LogoUrl
        },
        {
            Header: () => getTerm("subClient"),
            accessorKey: "clientName",
            id: "clientName",
            className: "",
        },
        {
            Header: () => getTerm("existingProjectStart"),
            accessorKey: "startDate",
            id: "startDate",
            sortDescFirst: true,
            size: 100,
            enableColumnFilter: false,
            Filter: DateFilter,
            filterOptions: { label: "Date" },
            Cell: ({ data, value }) => <DateCell value={value} />,
        },
        {
            Header: () => getTerm("existingProjectEnd"),
            accessorKey: "endDate",
            id: "endDate",
            sortDescFirst: true,
            size: 100,
            enableColumnFilter: false,
            Filter: DateFilter,
            filterOptions: { label: "Date" },
            Cell: ({ data, value }) => <DateCell value={value} noValue="Ongoing" />,
        },
        {
            Header: () => "Status",
            accessorKey: "status",
            id: "projectstatus",
            sortDescFirst: true,
            size: 100,
            Filter: SelectColumnFilter,
            filterOptions: { options: globalFilterRanges?.status || [] },
        },
        {
            Header: () => getTerm("revenueTD"),
            accessorKey: "revenueToDate",
            id: "revenueToDate",
            sortDescFirst: true,
            size: 140,
            Filter: MultiRangeFilter,
            filters: {
                min: globalFilterRanges?.revenueToDateMin ? Math.floor(globalFilterRanges?.revenueToDateMin) : "",
                max: globalFilterRanges?.revenueToDateMax ? Math.ceil(globalFilterRanges?.revenueToDateMax) : "",
                format: { isCurrency: true },
            },
            Cell: ({ data, value }) => {
                return <LargeNumber value={`$${abbrNum(value)}`} isHealthy={true} />;
            },
        },
    ];
};
